import React from "react";
import { Link } from "react-router-dom";
import OrderSuccessimg from "../../src/assets/images/orders_success.png";
import OrderFailedimg from "../../src/assets/images/payment_failed_img.png";
import OrderPendingimg from "../../src/assets/images/orders_success.png"; // TODO: swap for a real "pending" illustration if you have one
import { useState, useEffect } from "react";

// Maps DOKU's `status` param + SenangPay's `status_id` param onto one internal state.
function resolveStatus({ dokuStatus, statusId }) {
  // SenangPay flow sends status_id: "1" = success, anything else = failed
  if (statusId !== null) {
    return statusId === "1" ? "success" : "failed";
  }

  // DOKU flow sends status: SUCCESS/PAID, PENDING/PROCESSING, FAILED/EXPIRED
  if (dokuStatus) {
    const s = dokuStatus.toLowerCase();
    if (["success", "paid", "settled"].includes(s)) return "success";
    if (["processing", "pending"].includes(s)) return "pending";
    if (["failed", "expired", "voided", "cancelled", "canceled"].includes(s)) return "failed";
  }

  // No recognizable status param at all
  return "unknown";
}

function OrderSuccesspage() {
  const [orderId, setOrderId] = useState(null);
  const [status, setStatus] = useState("unknown"); // "success" | "pending" | "failed" | "unknown"
  const [transactionId, setTransactionId] = useState(null);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("order_id");
    const dokuStatus = urlParams.get("status"); // DOKU's param
    const statusId = urlParams.get("status_id"); // SenangPay's param
    const transaction_id = urlParams.get("transaction_id");
    const messages = urlParams.get("msg");

    // fix: original regex was a string literal "/_/g" and never matched anything
    const formattedMessage = messages ? messages.replace(/_/g, " ") : "";

    setOrderId(id);
    setStatus(resolveStatus({ dokuStatus, statusId }));
    setTransactionId(transaction_id);
    setMessage(formattedMessage);

    // NOTE: DOKU can legitimately redirect with status=processing before the
    // final result is known — true confirmation arrives async via DOKU's
    // server-side webhook. If you want this page to reflect the *final*
    // outcome instead of just what's in the URL, this is the place to poll
    // a backend endpoint like `GET /order_status?order_id=${id}` on an
    // interval (or on mount) once that endpoint exists, and use its
    // response to override `status` here.
  }, []);

  const content = {
    success: {
      img: OrderSuccessimg,
      imgStyle: {},
      heading: "Order Successful!",
      headingColor: "#374706",
    },
    pending: {
      img: OrderPendingimg,
      imgStyle: { width: "50%" },
      heading: "Payment Processing",
      headingColor: "#b58a00",
    },
    failed: {
      img: OrderFailedimg,
      imgStyle: { width: "50%" },
      heading: "Payment Failed",
      headingColor: "red",
    },
    unknown: {
      img: OrderFailedimg,
      imgStyle: { width: "50%" },
      heading: "Payment Status Unavailable",
      headingColor: "red",
    },
  }[status];

  return (
    <section className="order_success_page pt-40 pb-40">
      <div className="container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-lg-6 col-md-8 col-sm-12">
            <div className="inner-box text-center">
              <img src={content.img} style={content.imgStyle} alt="img" className="w-50" />

              <h4 style={{ color: content.headingColor }}>{content.heading}</h4>

              {status === "pending" ? (
                <p className="text-center">
                  We're confirming your payment with the provider. This can
                  take a few seconds — you'll receive a confirmation once it's
                  done.
                </p>
              ) : null}

              <p className="text-center">{message ? <>{message}</> : null}</p>
              <h6 className="text-center">
                Order ID: {orderId ? <>{orderId}</> : null}
              </h6>
              <h6 className="text-center">
                Transaction ID:{" "}
                {transactionId ? <>{transactionId}</> : "Pending confirmation"}
              </h6>
              <div className="btn_box">
                <Link to="/"> Go to home page</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OrderSuccesspage;